import React from 'react';
import { Button, DialogV2 } from 'c-components';
import { useCommonTranslation } from 'c-translation';
import { Stack } from '@mui/material';
import { PermissionName } from 'c-sdk';
import { IfHasAllPermissions } from 'c-auth-module/Components';
import ManualAudienceForm from './ManualAudienceForm';

const manualAudiencePerms = [PermissionName.AdminDisplaysManual_audience_upload];

interface ManualAudienceDialogProps {
    dialogState: {
        value: boolean;
        setFalse: () => void;
        setTrue: () => void;
    };
}

const ManualAudienceDialog: React.FC<ManualAudienceDialogProps> = ({ dialogState }) => {
    const t = useCommonTranslation();

    const downloadTemplate = () => {
        const csvContent = `Frame Id,Month,Day of the Week,Hour,Estimated Hourly Impacts,Route Version
1234931263,1,Monday,7,0.088505842,48.1.1
1234931263,1,Monday,8,0.149232592,48.1.1
1234931263,1,Monday,9,0.27870812,48.1.1`;

        try {
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', 'frame_template.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            // eslint-disable-next-line no-console -- the template download has no error UI; keep the failure visible for debugging
            console.log('Failed to download template:', error);
        }
    };

    return (
        <IfHasAllPermissions permissions={manualAudiencePerms}>
            <DialogV2
                onClose={dialogState.setFalse}
                open={dialogState.value}
                title="Modules.Displays.DisplaysList.uploadManualAudience"
            >
                <Stack gap={1}>
                    <Button onClick={downloadTemplate}>
                        {t('Modules.Displays.DisplaysList.downloadTemplate')}
                    </Button>
                    <ManualAudienceForm dialogState={dialogState} />
                </Stack>
            </DialogV2>
            <Button
                size="small"
                sx={{
                    minHeight: 26,
                    minWidth: 0,
                    px: 1,
                    py: 0.3,
                    fontSize: '0.72rem',
                    lineHeight: 1.1,
                }}
                onClick={dialogState.setTrue}
            >
                {t('Modules.Displays.DisplaysList.uploadManualAudience')}
            </Button>
        </IfHasAllPermissions>
    );
};

export default ManualAudienceDialog;
